import wheel19 from "../assets/images/Wheel19.png";
import wheel21 from "../assets/images/Wheel21.png";
import useCustomizerStore from "../state/customizer";

export const fetchCustomizerData = (displayMode, model) => {
  if (model === undefined && displayMode === undefined) {
    return [Xle, Limited, Platinum];
  } else if (model === 0) {
    return Xle;
  } else if (model === 1) {
    return Limited;
  } else if (model === 2) {
    return Platinum;
  }
};

export const getSelectedColorIndex = (model, displayMode = "exterior") => {
  const selection = useCustomizerStore.getState().selectionByModel?.[model];
  if (!selection) return 0;

  if (displayMode === "interior") {
    return selection.interior ?? 0;
  }

  return selection.exterior ?? 0;
};

export const setSelectedColorIndex = (
  model,
  index,
  displayMode = "exterior"
) => {
  const trim = fetchCustomizerData(undefined, model);
  if (!trim) return;

  if (displayMode === "interior") {
    trim.interior.selectedColor = index;
    trim.selectedInterior = index;
    useCustomizerStore.getState().setInteriorSelection(model, index);
    return;
  }

  trim.exterior.selectedColor = index;
  trim.selectedColor = index;
  useCustomizerStore
    .getState()
    .setExteriorSelection(model, index, trim.exterior.colors[index]);
};

export const getSelectedWheelIndex = (model) => {
  const selection = useCustomizerStore.getState().selectionByModel?.[model];
  if (!selection) return 0;

  return selection.wheel ?? 0;
};

export const setSelectedWheelIndex = (model, index) => {
  const trim = fetchCustomizerData(undefined, model);
  if (!trim) return;

  trim.wheels.selectedColor = index;
  trim.selectedWheel = index;
  useCustomizerStore.getState().setWheelSelection(model, index);
};

const black = "#000000";
const red = "#E20500";

const baseColors = [red, "#545251", "#FFFCF9", "#494848", black];

const interiorColors = ["#434343", "#CECBC6", "#404040"];

const Xle = {
  label: "xle",
  colors: baseColors,
  exterior: {
    colors: baseColors,
    selectedColor: 0,
  },
  flipper: {
    colors: [],
  },
  interior: {
    colors: [],
    selectedColor: null,
  },
  powertrain: {
    colors: [],
  },
  wheels: {
    colors: [],
    selectedColor: 0,
  },
  selectedColor: 0,
  selectedWheel: 0,
  selectedInterior: null,
};

const Limited = {
  label: "limited",
  colors: baseColors,
  flipper: {
    colors: [],
  },

  interior: {
    colors: interiorColors,
    selectedColor: 0,
  },
  powertrain: {
    colors: [],
  },
  exterior: {
    colors: baseColors,
    selectedColor: 2,
  },
  wheels: {
    colors: [wheel19, wheel21],
    selectedColor: 0,
    text: ['Standard 19"', 'AT 21"'],
  },
  selectedColor: 2,
  selectedWheel: 0,
  selectedInterior: 0,
};

const Platinum = {
  label: "platinum",
  colors: [
    ...baseColors,
    ["#D9D9D9", black],
    ["#545251", black],
    [red, black],
    ["#936445", black],
  ],
  exterior: {
    colors: [
      ...baseColors,
      ["#D9D9D9", black],
      ["#545251", black],
      [red, black],
      ["#936445", black],
    ],
    selectedColor: 8,
  },
  flipper: {
    colors: [],
  },
  powertrain: {
    colors: [],
  },
  interior: {
    colors: [],
    selectedColor: null,
  },

  wheels: {
    colors: [],
    selectedColor: 0,
  },
  selectedColor: 8,
  selectedWheel: 0,
  selectedInterior: null,
};
